import React, { Component } from "react";
import { Card, CardHeader, CardBody, Col } from "reactstrap";
import Variant from "./Variant";
import { CLOUDINARY_SHARE } from "../../helpers/cloudinaryConstants";

class ItemItem extends Component {
  shouldComponentUpdate(nextProps) {
    return this.props.gnObject.id !== nextProps.gnObject.id;
  }

  render() {
    const { gnObject, isChild } = this.props;
    return (
      <Col
        xs="12"
        md={isChild ? "12" : "6"}
        style={isChild ? { padding: 0 } : {}}
      >
        <Card>
          <CardHeader>Item</CardHeader>
          <CardBody>
            <h5>Business: {gnObject.business.name}</h5>
            <h6>ID: {gnObject.business.id}</h6>
            <hr />
            {!gnObject.image.isDefault && (
              <img
                style={{ width: "50%" }}
                src={`${CLOUDINARY_SHARE}/${gnObject.image.image.cloudinaryId}`}
              />
            )}

            <p>{gnObject.name}</p>
            <p>{gnObject.description}</p>
            {gnObject.variants.map((variant, idx) => (
              <Variant key={idx} variant={variant} />
            ))}
          </CardBody>
          {this.props.children}
        </Card>
      </Col>
    );
  }
}

export default ItemItem;



// WEBPACK FOOTER //
// ./src/views/Components/ItemItem.js